import React from "react";
export const EqualContentJustfy = ({ fontSize, children }) => {
    return <div className={`report-equal-contents-justify`} style={fontSize ? { fontSize: fontSize } : {}}>
        {children}
    </div>
}


// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/EqualContentJustify.jsx